import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Field, inputCls } from "@/components/LegsEditor";
import { useApi, errMsg } from "@/lib/api";

export default function SendProposalDialog({ p, open, onOpenChange, onSent }) {
  const api = useApi();
  const [to, setTo] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) setTo(p?.sent_to || "");
  }, [open, p]);

  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post(`/presentations/${p.id}/send`, { to: to.trim() });
      toast.success(`Proposal sent to ${data.sent_to}${data.copy_to && data.copy_to.toLowerCase() !== data.sent_to.toLowerCase() ? `. A copy is on its way to ${data.copy_to}` : ""}`);
      onOpenChange(false);
      onSent();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSending(false);
    }
  };

  if (!p) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111319] border-white/10 max-w-md" data-testid="send-proposal-dialog">
        <DialogHeader>
          <p className="eyebrow">Email client</p>
          <DialogTitle className="font-serif-display text-3xl font-normal text-white">{p.title}</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-zinc-400 -mt-1">
          Sent by JetSet Group in the portal's navy and gold design, with the proposal PDF attached and a Request to Book button under each option. Your client's replies come to you, and the broker gets an exact copy for their records.
        </p>
        <form onSubmit={send} className="space-y-4 mt-1">
          <Field label="Client email">
            <Input type="email" required className={inputCls} value={to} onChange={(e) => setTo(e.target.value)} placeholder="client@example.com" data-testid="send-proposal-email-input" />
          </Field>
          <div className="flex justify-end gap-3">
            <button type="button" className="frame-btn" onClick={() => onOpenChange(false)} data-testid="send-proposal-cancel-btn">Cancel</button>
            <button type="submit" className="frame-btn gold" disabled={sending} data-testid="send-proposal-submit-btn">
              <Send size={13} /> {sending ? "Sending…" : "Send proposal"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
